import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useIsFirebaseConsentGiven} from '@aboutyou/storage';
import {useValueAfterHydration} from '@aboutyou/ui-components';

export const useIsPushNotificationEnabled = () => {
  const {isActive} = useIsFeatureActive('web_mobile_push_notifications');
  const isCookieBannerAccepted = useIsFirebaseConsentGiven();

  return useValueAfterHydration(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    return isActive && isCookieBannerAccepted && 'Notification' in window;
  });
};
